import React from "react";
import { formatDayLabel } from "../Functions/Formatting";

/** Prev/next arrow used by the week, day and finals-round navigators. */
export function NavArrowButton({ direction, label, onClick, disabled }) {
  return (
    <button
      type="button"
      className="nav-button"
      onClick={onClick}
      aria-label={label}
      disabled={disabled}
    >
      <svg viewBox="0 0 20 20" width="18" height="18" fill="none" aria-hidden="true">
        <path
          d={direction === "prev" ? "M12.5 4.5 7 10l5.5 5.5" : "M7.5 4.5 13 10l-5.5 5.5"}
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
}

/** A day's worth of matches under a "Lunes 28 SEP" heading. */
export function DayGroup({ dateStr, children }) {
  return (
    <section className="day-group" aria-label={formatDayLabel(dateStr)}>
      <h3 className="day-heading">{formatDayLabel(dateStr)}</h3>
      <div className="day-group-list">{children}</div>
    </section>
  );
}

/** Card-shaped placeholders while a match list loads. */
export function MatchListSkeleton({ rows = 2 }) {
  return (
    <div className="match-skeleton-list" role="status" aria-label="Cargando partidos…">
      {Array.from({ length: rows }).map((_, i) => (
        <span key={i} className="skeleton match-skeleton" />
      ))}
    </div>
  );
}
